import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { tap, share } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Image } from '../model/image';
import { environment } from '../../environments/environment';
import { convertToQueryString } from '../utils';

interface ImageListResponse {
  result?: Image[];
  metadata: { pages: unknown[]; totalCount: number; pageSize: number };
}

@Injectable({ providedIn: 'root' })
export class ImageListService {
  private http = inject(HttpClient);
  private toasterService = inject(ToastrService);


  fetchParams: Record<string, string | number | boolean>;
  imagelist$: Observable<ImageListResponse>;

  url = (params: Record<string, string | number | boolean>): string => `${environment.api}/v1/images?${convertToQueryString(params)}`;
  imageUrl = (id: number): string => `${environment.api}/v1/images/${id}`;

  fetch(params: Record<string, string | number | boolean>): Observable<ImageListResponse> {
    this.fetchParams = params;
    console.log(`image-list.service.fetch: ${JSON.stringify(params)}`);
    this.imagelist$ = this.http.get<ImageListResponse>(this.url(params)).pipe(
      share(),
      tap((data: ImageListResponse) => {
        data.metadata.pages = Array(Math.ceil(data.metadata.totalCount / data.metadata.pageSize));
      })
    );
    return this.imagelist$;
  }

  refetch(): void {
    console.log(`image-list.service.refetch: ${JSON.stringify(this.fetchParams)}`);
    this.fetch(this.fetchParams);
  }

  deleteImage(image: Image): Subscription {
    console.log(`image-list.service.deleteImage: ${JSON.stringify(image)}`);
    return this.http.delete(this.imageUrl(image.id))
      .subscribe(() => {
        this.toasterService.success('Image deleted.', 'Successful!');
      }, () => {
      });
  }

  saveImage(image: Image): Subscription {
    console.log(`image-list.service.saveImage: ${JSON.stringify(image)}`);
    return this.http.put<Image>(this.imageUrl(image.id), image)
      .subscribe(() => {
        this.toasterService.success('Image saved.', 'Successful!');
      }, () => {
      });
  }
}
